import { render, staticRenderFns } from "./NutrientSummary.vue?vue&type=template&id=274568a9&scoped=true&lang=html&"
import script from "./NutrientSummary.vue?vue&type=script&lang=js&"
export * from "./NutrientSummary.vue?vue&type=script&lang=js&"
import style0 from "./NutrientSummary.vue?vue&type=style&index=0&id=274568a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274568a9",
  null
  
)

export default component.exports